import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'
import { PageContent } from '@components/pages'
import { PageContentHeader } from '@components/pages/page-content-header'
import { SiteStatsResponse, Paths } from '@logic'
import { withCachedLoading } from '@components/loading'
import { loadSiteStats } from '@helpers/loaders'
import { MetricsRow } from './components/MetricsRow'
import { QuickNavGrid, QuickNavItem } from './components/QuickNavGrid'
import styled from 'styled-components'
import { fontSizes } from '@src/styles/theme'

const SectionTitle = styled.h2<any>`
  font-family: 'NunitoSansSemiBold';
  font-size: ${fontSizes.XS};
  color: ${(props: any) => props.theme.white};
  margin: 0 0 16px 0;
`

const withSiteStats = withCachedLoading<SiteStatsResponse, any>(loadSiteStats)

type DashboardProps = RouteComponentProps<any> & {
  siteStats: SiteStatsResponse['siteStats']
}

const DashboardInner: React.FC<DashboardProps> = ({ siteStats, history }) => {
  const metrics = [
    { label: 'Organizations', value: siteStats.organizationCount },
    { label: 'Members', value: siteStats.memberCount },
    { label: 'Avg Members / Org', value: siteStats.memberAverage.toFixed(2) },
    { label: 'Waitlist', value: siteStats.waitlistCount },
  ]

  const navItems: QuickNavItem[] = [
    {
      title: 'Site Stats',
      description: 'Live metrics from site/stats',
      onClick: () => history.push(Paths.adminSiteStats),
    },
    {
      title: 'Users',
      description: 'Manage users, roles, and account status',
      onClick: () => history.push(Paths.adminUsers),
    },
    {
      title: 'Invitations',
      description: 'Send and manage organization invitations',
      onClick: () => history.push(Paths.adminOrganizationInvitation),
    },
    {
      title: 'Agent Monitor',
      description: 'Gateway and Prime status contracts',
      onClick: () => history.push(Paths.adminAgents),
    },
    {
      title: 'System Health',
      description: 'Gateway, Mattermost, and Prime health',
      onClick: () => history.push(Paths.adminHealth),
    },
    {
      title: 'Activity Log',
      description: 'Audit stream placeholder, no active endpoint',
      onClick: () => history.push(Paths.adminActivity),
    },
  ]

  return (
    <PageContent>
      <PageContentHeader title="Command Center" />
      <SectionTitle>Overview</SectionTitle>
      <MetricsRow metrics={metrics} />
      <SectionTitle>Quick Access</SectionTitle>
      <QuickNavGrid items={navItems} />
    </PageContent>
  )
}

export const CommandCenterDashboard = withSiteStats(withRouter(DashboardInner as any) as any)
